export default __webpack_public_path__ + "static/media/pro-elevate-cbb-2.1fe71bd7.png";